import React, { useContext, useState } from 'react';
import {
  OutlinedButton,
  ButtonText,
  ButtonIcon,
} from '@prisjakt/ui/button/variants';
import { IconChevronUp, IconChevronDown, IconFilter } from '@prisjakt/ui/icon';
import { defaultHiddenListOptions, getNumberOfActiveFilters } from '../utils';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { getAllFilters } from '../utils/filters-config';
import { AppContext } from '@prisjakt/ui-app-context';
import { Count } from './styles';
import { MediumUp } from 'src/ui/block';

const FilterToggleButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IFilterToggleButton>
>> = props => {
  const { showFilters, toggleHandler } = props;
  const { selectedFilters } = useContext(PriceListFilterContext);
  const { t, market } = useContext(AppContext);
  const [hiddenListOptions] = useState<string[]>(
    defaultHiddenListOptions(market)
  );
  const availableFilters = getAllFilters(
    t,
    selectedFilters,
    hiddenListOptions
  ).filter(f => !f.quickFilter);
  const nbrOfActiveFilters = getNumberOfActiveFilters(
    selectedFilters,
    availableFilters
  );

  return (
    <OutlinedButton onClick={toggleHandler}>
      <ButtonIcon>
        <IconFilter />
      </ButtonIcon>
      <ButtonText>
        {t('filter', 'filter.title')}
        {nbrOfActiveFilters > 0 && <Count>&nbsp;({nbrOfActiveFilters})</Count>}
      </ButtonText>
      <MediumUp>
        <ButtonIcon>
          {showFilters ? <IconChevronUp /> : <IconChevronDown />}
        </ButtonIcon>
      </MediumUp>
    </OutlinedButton>
  );
};

interface IFilterToggleButton {
  showFilters: boolean;
  toggleHandler: () => void;
}

export default FilterToggleButton;
